import { observable, action } from "mobx";

class ImportProgressJobs {
  @observable isShowPopup = false;
  @observable csvImportJobs = [];
  @observable liImportJobs = [];
  @observable totalCsvActiveJobs = 0;
  @observable totalCsvInProgressJobs = 0;
  @observable totalLiActiveJobs = 0;
  @observable totalLiInProgressJobs = 0;

  @action
  setTotalLiActiveJobs = (val = 0) => {
    this.totalLiActiveJobs = val;
  };
  @action
  setTotalLiInProgressJobs = (val = 0) => {
    this.totalLiInProgressJobs = val;
  };

  @action
  setTotalCsvActiveJobs = (val = 0) => {
    this.totalCsvActiveJobs = val;
  };
  @action
  setTotalCsvInProgressJobs = (val = 0) => {
    this.totalCsvInProgressJobs = val;
  };

  @action
  setIsShowPopup = (val = false) => {
    this.isShowPopup = val;
  };

  @action
  setCsvImportJobs = (val = []) => {
    this.csvImportJobs = val;
  };
  @action
  setLiImportJobs = (val = []) => {
    this.liImportJobs = val;
  };
}
const importProgressJobs = new ImportProgressJobs();
export { importProgressJobs };
